export default __webpack_public_path__ + "static/media/balloon3.684ede61.png";